import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'

export const style: CSSResult = css`
  .csc-image-hotspot-popup {
    --cse-paper-padding-y: ${csSpacing.spacing05};
    --cse-paper-padding-x: ${csSpacing.spacing05};
  }

  .csc-image-hotspot-popup cse-paper {
    display: block;
    width: 250px;
    max-width: 250px;
  }

  .text-wrapper {
    align-items: center;
    display: grid;
    grid-template-columns: 1fr auto;
    grid-template-rows: auto;
    width: 100%;
  }

  .csc-image-hotspot-popup cse-image {
    width: 100%;
    height: 100px;
    max-height: 100px;
  }
`
